<template>
  <li class="menu-aide">
  	<router-link :to="{ name: 'FAQ' }" title="Trouver de l'aide">
  		<svgicon icon="help" class="help-icon"></svgicon>
  		<span>Aide</span>
  	</router-link>
  </li>
</template>

<script>
export default {
  name: 'header-menu-help',
}
</script>
